import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ShopProvider } from "@/context/ShopContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import ProductPage from "@/pages/ProductPage";
import CheckoutPage from "@/pages/CheckoutPage";
import WishlistPage from "@/pages/WishlistPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import MetaRoutePageViews from "@/analytics/MetaRoutePageViews";
import { SubscribePopup } from "@/components/SubscribePopup";
import { SmoothScroll } from "@/components/motion/SmoothScroll";

const ScrollToTop = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, search]);
  return null;
};

function App() {
  return (
    <div className="App bg-ivory min-h-screen">
      <ShopProvider>
        <BrowserRouter>
          <SmoothScroll />
          <ScrollToTop />
          <MetaRoutePageViews />
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/shop" element={<ShopPage />} />
            <Route path="/product/:id" element={<ProductPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/wishlist" element={<WishlistPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
          <Footer />
          <CartDrawer />
          <WhatsAppFloat />
          <SubscribePopup />
          <Toaster position="top-center" toastOptions={{ style: { background: "#FDFBF7", border: "1px solid rgba(191,161,95,0.4)", color: "#1A1A1A", borderRadius: "2px" } }} />
        </BrowserRouter>
      </ShopProvider>
    </div>
  );
}

export default App;
